import {MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { BtnOutlined, CmbWithTitle, Column, ContainerInside, Items } from "../styled.components";
import FooterBtns from "../FooterBtns";
import { cloneObjectWithRegExp, hotToast, validateData } from "utils";
import { InputsGroup } from "Components/Inputs";
import { InputModal } from "Components/V1/InputModal";
import Table from "Components/V1/Table";
import SaveIcon from "@mui/icons-material/Save";
import ServiceArchivo from "service/archivos";
import { ICombo } from "Interfaces/Generics";
import IRelUsuarioMarcaOperacion from "ITables/RelUsuarioMarcaOperacion";


const SCHEMAUSUARIO = {
    error: false,
    required: true,
    type: "text",
    textError: "Ingresa un nombre valido",
};
const SCHEMADATA = {
    idArchivo: {
        error: false,
        required: true,
        type: "select",
        textError: "Ingresa un un archivo valido",
    },
    idMarca: {
        error: false,
        required: true,
        type: "select",
        textError: "Ingresa una marca valido",
    },
    idTipoOperacion: {
        error: false,
        required: true,
        type: "select",
        textError: "Ingresa un tipo de operacion valida",
    }

};

interface IRelUsrArchivoMT {
    idArchivo: number,
    idMarca: number,
    idTipoOperacion: number,
    nombreArchivo?: string,
    marcaTipoOperacion?: string,
    idRelacionArchivoMarcaTipoOp: number,
}

interface IFile{
    value:number,
    label: string,
    idRelacionArchivoMarcaTipoOp: number,
}


const CreateRelUserFiles = ({ reloadData, closeModal, loading, setLoading }: any) => {
    const [idUsuario, setIdUsuario] = useState<number>(0)
    const [validateUser, setValidateUser] = useState(cloneObjectWithRegExp(SCHEMAUSUARIO));

    const [relUsrArchivoMT, setRelUsrArchivoMT] = useState<IRelUsrArchivoMT>({
        idArchivo: 0,
        idMarca: 0,
        idTipoOperacion: 0,
        idRelacionArchivoMarcaTipoOp: 0,
    })
    const [validate, setValidate] = useState(cloneObjectWithRegExp(SCHEMADATA));
    const [arrayRelUsrArchivoMT, setArrayRelUsrArchivoMT] = useState<Array<IRelUsrArchivoMT>>([])


    const [arrayUsers, setArrayUsers] = useState<Array<ICombo>>([])
    const [arrayArchivos, setArrayArchivos] = useState<Array<IFile>>([])
    const [arrayMarcas, setArrayMarcas] = useState<Array<ICombo>>([])
    const [arrayTiposOperacion, setArrayTiposOperacion] = useState<Array<ICombo>>([])

    useEffect(() => {
        getAll();
    }, [])

    const getAll = async () => {
        ServiceArchivo.cbmUsuariosNoConfig({ setterFunc: setArrayUsers });
    }

    const handleArchivo = (e: any) => {
        let value = e.target.value;
        setValidate((old: any) => ({ ...old, idArchivo: { ...old['idArchivo'], error: false } }))
        const oFile = arrayArchivos.find((item : any) => item.value === value);
        console.log(oFile)
        setRelUsrArchivoMT((old: any) => ({
            ...old,
            idArchivo: value,
            nombreArchivo: arrayArchivos.find(d => d.value === value)?.label,
            idRelacionArchivoMarcaTipoOp : oFile?.idRelacionArchivoMarcaTipoOp,
        }))
    }

    const handleMarca = (e: any) => {
        let value = e.target.value;
        setValidate((old: any) => ({ ...old, idMarca: { ...old['idMarca'], error: false } }))
        ServiceArchivo.getTiposOperacion(setArrayTiposOperacion,value, idUsuario);
        setRelUsrArchivoMT((old: any) => ({
            ...old,
            idMarca: value,
            idArchivo: 0,
            idRelacionArchivoMarcaTipoOp: 0,
            idTipoOperacion: 0,
        }))
    }

    const handleOperacion = (e: any) => {
        let value = e.target.value;
        console.log(value)
        setValidate((old: any) => ({ ...old, idTipoOperacion: { ...old['idTipoOperacion'], error: false } }))
        setRelUsrArchivoMT((old: any) => ({
            ...old,
            idTipoOperacion: value,
            idArchivo: 0,
            idRelacionArchivoMarcaTipoOp : 0,
        }))
        ServiceArchivo.getFiles(setArrayArchivos,relUsrArchivoMT.idMarca, value, idUsuario);
    }

    const onSubmit = async () => {
        if(idUsuario === 0) return hotToast("El campo de usuario no puede estar vacio","ERROR")
        if(arrayRelUsrArchivoMT.length === 0) return hotToast("Debes ingresar almenos una relacion de Archivo - Marca - Operación","ERROR")
        setLoading(true);
        const request = arrayRelUsrArchivoMT.map(d => ({IdRelacionArchivoMarcaTipoOp:d.idRelacionArchivoMarcaTipoOp,Checked: true}))
        let response = await ServiceArchivo.updateRelUsuariosArchivos(request,idUsuario);
        if (response) {
            hotToast("El registro se guardo correctamente", "SUCCESS");
            setLoading(false);
            reloadData && reloadData();
            closeModal && closeModal();
            setValidate(SCHEMADATA);
        }
        setLoading(false);
    };

    const handleDelete = (item: any) => {
        setArrayRelUsrArchivoMT((old: any) => {
            let arr = [...old];
            const index = arr.findIndex((d: any) => item.idArchivo === d.idArchivo && item.idMarca === d.idMarca && item.idTipoOperacion === d.idTipoOperacion);
            arr.splice(index, 1)
            return arr;
        });

    }
    const saveColumn = () => {
        let flag = validateData({ validate, data: relUsrArchivoMT }, setValidate);
        if (!flag) {
            const fl:boolean = arrayRelUsrArchivoMT.some(d => 
                d.idArchivo === relUsrArchivoMT.idArchivo && 
                d.idMarca === relUsrArchivoMT.idMarca &&
                d.idTipoOperacion === relUsrArchivoMT.idTipoOperacion
            )
            if(fl){ return hotToast("La relacion ya existe","ERROR")}
            const $marca = arrayMarcas.find((d) => d.value === relUsrArchivoMT.idMarca)?.label;
            const $operacion = arrayTiposOperacion.find((d) => d.value === relUsrArchivoMT.idTipoOperacion)?.label;

            setArrayRelUsrArchivoMT((old) => [...old, {
                ...relUsrArchivoMT,
                marcaTipoOperacion: `${$marca} - ${$operacion}`
            }])
            setRelUsrArchivoMT({
                idArchivo: 0,
                idMarca: 0,
                idTipoOperacion: 0,
                nombreArchivo: '',
                marcaTipoOperacion: '',
                idRelacionArchivoMarcaTipoOp: 0,
            });
        }
    }

    const handleFindBrand = (userId : number) => {
        ServiceArchivo.getMarcas(setArrayMarcas, userId);
    }

    return (
        <ContainerInside>
            <InputsGroup>
                <CmbWithTitle>
                    <span>Selecciona al usuario:</span>
                    <InputModal
                        name="idUsuario"
                        id="txtUser"
                        minWidth={'300px'}
                        onChange={(e: any) => {
                            setIdUsuario(e.target.value);
                            setValidateUser((old: any) => ({ ...old, error: false }))
                            handleFindBrand(e.target.value)
                        }
                        }
                        select
                        value={idUsuario}
                        error={validateUser.error}
                        helperText={validateUser.error && validateUser.textError}
                    >
                        {arrayUsers &&
                            arrayUsers.map((item, index) => {
                                return (
                                    <MenuItem key={index} value={item.value}>
                                        {item.label}
                                    </MenuItem>
                                );
                            })}
                    </InputModal>
                </CmbWithTitle>
            </InputsGroup>

            <Items>
                <Column ai={"flex-end"}>
                    <CmbWithTitle error={validate.idMarca.error}>
                        <span>Marca</span>
                        <InputModal
                            name="idMarca"
                            id="slcIdMarca"
                            minWidth={'300px'}
                            onChange={handleMarca}
                            value={relUsrArchivoMT.idMarca}
                            disabled = {idUsuario ? false : true}
                            select
                            error={validate.idMarca.error}
                            helperText={validate.idMarca.error ? validate.idMarca.textError : !idUsuario && "Para continuar seleccione un usuario"}
                        >
                            {arrayMarcas &&
                                arrayMarcas.map((item, index) => {
                                    return (
                                        <MenuItem key={index} value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    );
                                })}
                        </InputModal>
                    </CmbWithTitle>
                    <CmbWithTitle error={validate.idTipoOperacion.error}>
                        <span>Tipo de Operación</span>
                        <InputModal
                            name="idTipoOperacion"
                            id="slcIdTipoOperacion"
                            minWidth={'300px'}
                            onChange={handleOperacion}
                            value={relUsrArchivoMT.idTipoOperacion}
                            select
                            disabled = {idUsuario ? false : true}
                            error={validate.idTipoOperacion.error}
                            helperText={validate.idTipoOperacion.error ? validate.idTipoOperacion.textError : !idUsuario && "Para continuar seleccione un usuario"}
                        >
                            {arrayTiposOperacion &&
                                arrayTiposOperacion.map((item, index) => {
                                    return (
                                        <MenuItem key={index} value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    );
                                })}
                        </InputModal>

                    </CmbWithTitle>
                    <CmbWithTitle error={validate.idArchivo.error}>
                        <span>Archivo</span>
                        <InputModal
                            name="idArchivo"
                            id="slcIdArchivo"
                            minWidth={'300px'}
                            onChange={handleArchivo}
                            value={relUsrArchivoMT.idArchivo}
                            select
                            error={validate.idArchivo.error}
                            helperText={validate.idArchivo.error && validate.idArchivo.textError}
                        >
                            {arrayArchivos &&
                                arrayArchivos.map((item, index) => {
                                    return (
                                        <MenuItem key={index} value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    );
                                })}
                        </InputModal>
                    </CmbWithTitle>
                    <BtnOutlined
                        variant="outlined"
                        startIcon={<SaveIcon />}
                        onClick={saveColumn}
                    >
                        Guardar
                    </BtnOutlined>
                </Column>
                <Column jc={"flex-start"} mh="40vh" style={{overflow:'auto'}}>
                    <Table
                        IColumns={IRelUsuarioMarcaOperacion({
                            handleDelete
                        })}
                        IData={arrayRelUsrArchivoMT}
                        simply
                    />
                </Column>
            </Items>

            <FooterBtns
                handleCancel={closeModal}
                handleSubmit={onSubmit}
                loader={loading}
            />
        </ContainerInside >
    );
};

export default CreateRelUserFiles;
